
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/my/saved",
      function () {
        return require("private-next-pages/jobs/my/saved/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/my/saved"])
      });
    }
  